import * as React from "react";
const SvgInsertDriveFile = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.01 2 4 22h16V8l-6-6H4.01zM13 9V3.5L18.5 9H13z",
  fill: "currentColor"
}));
export default SvgInsertDriveFile;